import * as publicApi from "../../../../service/publicApi";
import React, { useState, useContext, useEffect } from "react";
import InputV2 from "../../../material/input/InputV2";
import Select from "../../../material/select/Select";
import { CurrentUserContext } from "../../../../App";

const Address = ({ list, address, onInputChange }) => {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [labDistrictList, setLabDistrictList] = useState([]);
  const [labSubDistrictList, setLabSubDistrictList] = useState([]);

  useEffect(() => {
    if (address.province_id) {
      getLabDistrictList(address.province_id);
    }
  }, [address.province_id]);

  useEffect(() => {
    if (address.district_id) {
      getLabSubDistrictList(address.district_id);
    }
  }, [address.district_id]);

  const getLabDistrictList = async (provinceId) => {
    let res = await publicApi.getDistrictList(provinceId);
    if (res["data"]["code"] === 200) {
      setLabDistrictList(
        res["data"]["district_list"].map((item) => ({
          key: item["district_id"],
          value: item["district_name"],
        })),
      );
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getLabSubDistrictList = async (districtId) => {
    let res = await publicApi.getSubDistrictList(districtId);
    if (res["data"]["code"] === 200) {
      setLabSubDistrictList(
        res["data"]["sub_district_list"].map((item) => ({
          key: item["sub_district_id"],
          value: item["sub_district_name"],
        })),
      );
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className="w-full gap-[10px] rounded-[6px] border-[#E2E2E4] border p-[9px_16px] mb-[10px]">
      <h1 className="text-[18px] mb-[10px]">ที่อยู่</h1>

      <div className="flex justify-center items-center flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          Email (ถ้ามี)
          <InputV2
            type="text"
            placeholder="email"
            value={address.email}
            onChangeEvt={(value) => onInputChange("email", value)}
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          เบอร์โทร
          <InputV2
            type="text"
            placeholder="เบอร์โทร"
            value={address.phone_number}
            onChangeEvt={(value) => onInputChange("phone_number", value)}
          />
        </div>
      </div>

      <div className="flex justify-center items-center flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          บ้านเลขที่
          <InputV2
            type="text"
            placeholder="บ้านเลขที่"
            value={address.address}
            onChangeEvt={(value) => onInputChange("address", value)}
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          อาคารตึกชั้น
          <InputV2
            type="text"
            placeholder="อาคารตึกชั้น"
            value={address.building}
            onChangeEvt={(value) => onInputChange("building", value)}
          />
        </div>
      </div>

      <div className="flex justify-center items-center flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          หมู่
          <InputV2
            type="text"
            placeholder="หมู่"
            value={address.village_number}
            onChangeEvt={(value) => onInputChange("village_number", value)}
          />
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          จังหวัด
          <Select
            label=""
            placeholder="จังหวัด"
            value={address.province_id}
            setValue={(e) => {
              onInputChange("province_id", e);
              getLabDistrictList(e);
            }}
            list={list}
          ></Select>
        </div>
      </div>

      <div className="flex justify-center items-center flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          อำเภอ
          <Select
            placeholder="อำเภอ"
            value={address.district_id}
            setValue={(e) => {
              onInputChange("district_id", e);
              getLabSubDistrictList(e);
            }}
            list={labDistrictList}
          ></Select>
        </div>

        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          ตำบล
          <Select
            placeholder="ตำบล"
            value={address.sub_district_id}
            setValue={(e) => onInputChange("sub_district_id", e)}
            list={labSubDistrictList}
          ></Select>
        </div>
      </div>

      <div className="flex flex-row gap-[16px] md:flex-col w-full mb-[16px]">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          รหัสไปรษณีย์
          <InputV2
            type="text"
            placeholder="รหัสไปรษณีย์"
            value={address.post_code}
            onChangeEvt={(value) => onInputChange("post_code", value)}
          />
        </div>
      </div>
    </div>
  );
};
export default Address;
